import clsx from "clsx";
import {SubmitButton} from "components/Button";
import {FormCard} from "components/Form";
import {DashboardLayout} from "components/Layout";
import {CircleLoader} from "components/Loader";
import {Formik} from "formik";
import {useDetailDiagnosa, useUpdateDiagnosa} from "hooks/SuperAdmin/Diagnosa";
import {useToast} from "hooks/useToast";
import {useEffect, useRef} from "react";
import {useHistory, useRouteMatch} from "react-router-dom";
import {convertErrorMessageFormat} from "utils/converter";
import * as Yup from "yup";

const FormSchemaValidation = Yup.object().shape({
	name: Yup.string().required("Nama diagnosa wajib di isi"),
});
const FormInitialValues = {name: ""};

export function MasterDiagnosaEditPage() {
	const {showToast} = useToast();
	const formikRef = useRef();
	const history = useHistory();
	const matchParams = useRouteMatch();
	const {params} = matchParams;
	const {id} = params;
	const {isLoading: isFetching, data: detailKategoriPemeriksaan} = useDetailDiagnosa(id);
	const {mutate, isLoading: isSubmitting} = useUpdateDiagnosa();
	const handleSubmit = formData => {
		mutate(
			{id, ...formData},
			{
				onSuccess: () => {
					showToast("success", "Data berhasil diperbarui");
					history.push("/master-diagnosa");
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	useEffect(() => {
		if (detailKategoriPemeriksaan) formikRef.current.setFieldValue("name", detailKategoriPemeriksaan?.data?.name);
	}, [detailKategoriPemeriksaan]);

	if (isFetching) {
		return (
			<DashboardLayout>
				<FormCard title="Edit Diagnosa">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<Formik
				initialValues={FormInitialValues}
				innerRef={formikRef}
				validationSchema={FormSchemaValidation}
				onSubmit={handleSubmit}>
				{({handleSubmit, handleBlur, handleChange, values, errors}) => (
					<FormCard
						backTitle="Daftar List Diagnosa"
						title="Edit Diagnosa"
						onBackButtonClick={() => history.push("/master-diagnosa")}>
						<div class="row gx-2 mb-5">
							<div class="col-sm-12 col-lg-6  col-xs-12">
								<div class="setting-item">
									<label class="setting-label required">Nama Diagnosa</label>
									<input
										class={clsx("form-control", errors?.name && "form-control-error")}
										disabled={isSubmitting}
										name="name"
										placeholder=""
										type="text"
										value={values?.name}
										onBlur={handleBlur}
										onChange={handleChange}
									/>
									{errors.name && <p className="form-error-item-message">{errors.name}</p>}
								</div>
							</div>
						</div>

						<div class="text-center my-3">
							<SubmitButton
								className="btn btn-orange d-inline-block mw-250"
								disabled={!FormSchemaValidation.isValidSync(values)}
								loading={isSubmitting}
								text="Simpan Perubahan"
								onClick={handleSubmit}
							/>
						</div>
					</FormCard>
				)}
			</Formik>
		</DashboardLayout>
	);
}
